import * as React from 'react';
import PropTypes from 'prop-types';
import { styled } from '@mui/material/styles';
import { grey } from '@mui/material/colors';
import Box from '@mui/material/Box';
import SwipeableDrawer from '@mui/material/SwipeableDrawer';
import { Button } from '@mui/material';
import KeyboardArrowDownRoundedIcon from '@mui/icons-material/KeyboardArrowDownRounded';
import IndustriesAccordion from '../IndustriesAccordion';

const drawerBleeding = 56;

const Puller = styled(Box)(({ theme }) => ({
  width: 32,
  height: 5,
  backgroundColor: grey[300],
  borderRadius: 3,
  position: 'absolute',
  top: 10,
  left: 'calc(50% - 16px)',
}));

function SwipeableEdgeDrawer(props) {
  const { window, text, content, sx, industryName, popularIndustries, subTab } = props;
  const [open, setOpen] = React.useState(false);

  const toggleDrawer = (newOpen) => () => {
    setOpen(newOpen);
  };

  const container = window !== undefined ? () => window().document.body : undefined;

  return (
    <div>
      <Box sx={{ textAlign: 'center' }}>
        <Button
          variant="outlined"
          onClick={toggleDrawer(true)}
          endIcon={<KeyboardArrowDownRoundedIcon sx={{ fontSize: '1.2rem !important', opacity: 0.6 }} />}
          sx={{
            width: '100%',
            textTransform: 'none',
            justifyContent: 'space-between',
            borderRadius: '10px',
            borderColor: 'rgba(0,0,0,0.12)',
            color: 'text.primary',
            fontWeight: 600,
            fontSize: '.85rem',
            py: 1,
            '&:hover': {
              borderColor: 'rgba(0,0,0,0.2)',
              backgroundColor: 'rgba(22,27,87,0.02)',
            },
          }}
        >
          {text}
        </Button>
      </Box>
      <SwipeableDrawer
        container={container}
        anchor="bottom"
        open={open}
        onClose={toggleDrawer(false)}
        onOpen={toggleDrawer(true)}
        swipeAreaWidth={drawerBleeding}
        disableSwipeToOpen={true}
        ModalProps={{ keepMounted: true }}
        PaperProps={{
          sx: {
            height: `calc(79% - ${drawerBleeding}px)`,
            overflow: 'visible',
          },
        }}
        sx={{ zIndex: 111 }}
      >
        {open && (
          <Box
            sx={{
              position: 'absolute',
              top: -drawerBleeding,
              borderTopLeftRadius: 14,
              borderTopRightRadius: 14,
              visibility: 'visible',
              right: 0,
              left: 0,
              zIndex: 111,
              height: '3.5rem',
              backgroundColor: '#fff',
              textAlign: 'center',
              display: { xs: 'block', sm: 'none' },
              boxShadow: '0 -2px 10px rgba(0,0,0,0.08)',
            }}
          >
            <Puller onClick={toggleDrawer(false)} sx={{ cursor: 'pointer' }} />
          </Box>
        )}
        <Box
          sx={{
            px: 2,
            pt: 3,
            pb: 2,
            height: '100%',
            overflow: 'auto',
            backgroundColor: '#fff',
            display: { xs: 'block', sm: 'none' },
          }}
        >
          <IndustriesAccordion
            industryName={industryName}
            popularIndustries={popularIndustries}
            subTab={subTab}
            onIndustryClick={() => toggleDrawer(false)}
            sx={{ ...sx }}
          />
        </Box>
      </SwipeableDrawer>
    </div>
  );
}

SwipeableEdgeDrawer.propTypes = {
  window: PropTypes.func,
};

export default SwipeableEdgeDrawer;
